import styled, { css } from "styled-components";

const smallMixin = css`
  padding: 1em 2em;
  font-size: 0.875rem;
`;

const pointyMixin = css`
  border-bottom-left-radius: 0;
`;

const inlineMixin = css`
  display: flex;
  justify-content: space-between;
  grid-auto-flow: initial;
  gap: initial;
  border-radius: 100px;
  background: #f8f8f8;
  ${(props) =>
    props.focused ? "box-shadow: inset 0 5px rgba(0, 0, 0, 0.05);" : ""}
`;

export const StyledContainer = styled.div`
  display: grid;
  grid-auto-flow: row;
  gap: 1em;

  ${(props) => (props.inline ? inlineMixin : "")}

  @media (min-width: 600px) {
    ${inlineMixin}
    ${(props) => (props.inputStyle === "pointy" ? pointyMixin : "")}
  }
  transition: 0.2s;
  ${(props) => (props.inputStyle === "pointy" ? pointyMixin : "")}
`;

export const StyledInput = styled.input`
  border: none;
  min-width: 0;
  border-radius: 100px;
  background: #f8f8f8;
  color: #434343;
  font-size: 1.125rem;
  padding: 0.6em 1em;
  outline: none;
  transition: 0.3s;
  width: 100%;
  box-sizing: border-box;
  ${(props) =>
    props.focused && !props.inline
      ? "box-shadow: inset 0 5px rgba(0, 0, 0, 0.05);"
      : ""}

  ${(props) => (props.inline ? "background: transparent;" : "")}

  @media (min-width: 600px) {
    background: transparent;
    font-size: 1.375rem;
    flex: 1;
    box-shadow: none;
    ${(props) =>
      props.size === "small"
        ? `
      font-size: 0.875rem;
    `
        : ""}
  }

  &::placeholder {
    color: #434343;
  }

  ${(props) => (props.size === "small" ? smallMixin : "")}
  ${(props) => (props.inputStyle === "pointy" ? pointyMixin : "")}
`;
